import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/average-periodic-payment',
  component: () => import('../../routes/AveragePeriodicPayment.svelte'),
  card: {
    id: 'average-periodic-payment',
    title: 'Average Periodic Payment',
    description: 'Calculate loan or investment payments using the annuity payment formula, with full amortization schedule.',
    icon: 'payments',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/average-periodic-payment',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Average Periodic Payment Calculator – Loan & Annuity Payment Formula',
    description: 'Free periodic payment calculator. Computes loan or investment payments using the annuity formula PMT = PV × r / (1 − (1+r)^−n), with full amortization schedule.',
  },
};

export default meta;